module.exports = new __parcel__URL__("machinarium.7969e817.jpg").toString();